// Referral promo code (?promo-code=) handling, shared by every sign-up path.
//
// The code is persisted in a cookie so it survives the Google OAuth round-trip and any later
// sign-up path even after the URL query is gone — stored the same way as frontend_user_id
// (.chargeback.io, 30 days). Attaching a new account to its referrer then happens on the backend
// for every creation path; the frontend just always sends the code.
//
// Kept dependency-free on purpose so it can be imported from Services/Api.js without a cycle.

const REFERRAL_PROMO_CODE_COOKIE = "referral_promo_code"
const REFERRAL_PROMO_CODE_AGE = 60 * 60 * 24 * 30 // 30 days

const cookieDomain = () =>
  window.location.hostname.includes("localhost") ? "localhost" : ".chargeback.io"

const readCookie = (name) => {
  const cookies = document.cookie.split("; ")
  for (let cookie of cookies) {
    const [key, value] = cookie.split("=")
    if (key === name) return value
  }
  return null
}

// Persist the referral code from `?promo-code=` the moment the link is opened.
export const captureReferralPromoCode = () => {
  const code = new URLSearchParams(window.location.search).get("promo-code")
  if (!code) return
  document.cookie = `${REFERRAL_PROMO_CODE_COOKIE}=${code}; path=/; max-age=${REFERRAL_PROMO_CODE_AGE}; domain=${cookieDomain()}; SameSite=None; Secure`
}

// Single source of truth for every sign-up path: current URL wins, cookie is the fallback.
export const getReferralPromoCode = () =>
  new URLSearchParams(window.location.search).get("promo-code") ||
  readCookie(REFERRAL_PROMO_CODE_COOKIE) ||
  null
